import { makeid } from '@speechki-frontend/shared/helpers/functions';

export const createSegment = params => {
    const {
        start = 0,
        duration = 0,
        width = 0,
        left = 0,
        speed = 1,
        shift = 0,
        rtl = false
    } = params;
    return {
        id: makeid(),
        type: 'none',
        cut: false,
        width,
        left,
        rtl,
        speed,
        start: Math.round(start),
        duration: Math.round(duration),
        shift,
        isNew: !!(!width || !left),
        isSaved: false,
        isDeleted: false,
        hasChange: false,
        ...params
    };
};

export const genSegments = (chunks, precision) => {
    const sortedChunks = Object.values(chunks)
        .flat()
        .sort((a, b) => a.start - b.start);
    const segments = [];

    for (let i = 0; i < sortedChunks.length; i++) {
        const { start = 0, end = 0, speed = null } = sortedChunks[i];
        const type = speed ? 'speed' : 'trim';
        const duration = speed ? Math.round((end - start) / speed) : 0;
        const width = speed ? duration / precision : 1;
        const cut = !speed;
        const isNew = false;
        const isSaved = true;
        const segment = createSegment({
            start,
            end,
            speed,
            type,
            duration,
            width,
            cut,
            isNew,
            isSaved
        });
        let shift = 0;

        if (i > 0) {
            for (let j = 0; j < i; j++) {
                const prevSegment = segments[j];
                const chunkDurationDiff =
                    prevSegment.type === 'speed'
                        ? prevSegment.end - prevSegment.start - prevSegment.duration
                        : prevSegment.end - prevSegment.start;

                shift -= chunkDurationDiff;
            }
        }

        segment.shift = shift;
        segments.push(segment);
    }
    return segments;
};

export const getPrecision = ms => {
    switch (true) {
        case ms < 1001:
            return 1;

        case ms < 3001:
            return 2;

        case ms < 5001:
            return 5;

        case ms < 10001:
            return 10;

        case ms < 15001:
            return 15;

        case ms < 20001:
            return 20;

        case ms < 25001:
            return 25;

        default:
            return 30;
    }
};

export const formChunksData = (segments, hasChanges) => {
    const speedChunks = [];
    const trimChunks = [];

    segments
        .filter(({ isDeleted }) => !isDeleted)
        .forEach(segment => {
            if (segment.type === 'speed') {
                const chunk = {
                    start: parseInt(segment.start),
                    speed: segment.speed
                };

                chunk.end = hasChanges
                    ? parseInt(segment.end)
                    : parseInt(segment.start + segment.duration);

                speedChunks.push(chunk);
            }

            if (segment.type === 'trim') {
                const chunk = {
                    start: parseInt(segment.start)
                };

                chunk.end = hasChanges
                    ? parseInt(segment.end)
                    : parseInt(segment.start + segment.duration);

                trimChunks.push(chunk);
            }
        });
    return { speed_chunks: speedChunks, trim_chunks: trimChunks };
};

export const reduceAudioPeak = (data, spp, scroll, width, resolution) => {
    let drawData = new Array(width);
    let startSample = scroll * spp;
    let skip = Math.ceil(spp / resolution);

    // For each pixel in draw area
    for (let i = 0; i < width; i++) {
        let min = 0; // minimum value in sample range
        let max = 0; // maximum value in sample range
        let pixelStartSample = startSample + i * spp;

        // Iterate over the sample range for this pixel (spp)
        // and find the min and max values.
        for (let j = 0; j < spp; j += skip) {
            const index = pixelStartSample + j;
            if (index < data.length) {
                let val = data[index];
                if (val > max) {
                    max = val;
                } else if (val < min) {
                    min = val;
                }
            }
        }

        drawData[i] = [min, max];
    }
    return drawData;
};

export const getAudioGenerationExtra = bookpart => {
    const defaultChunks = {
        speed_chunks: [],
        trim_chunks: []
    };

    if (bookpart.audio_generation_extra == null) {
        return defaultChunks;
    }

    return {
        ...defaultChunks,
        ...bookpart.audio_generation_extra
    };
};
